module.exports = __webpack_public_path__ + "static/media/gem.081e6748.png";